import React from 'react';

const DoctorsGridYonetim: React.FC = () => {
  return <div className="card" style={{ padding: 16 }}>Doktorlar Grid (Doctors Grid)</div>;
};

export default DoctorsGridYonetim;
